import React, { Dispatch, SetStateAction, useContext, useEffect } from "react";
// import { Button } from "primereact/button";
import useDarkTheme from "app/hooks/useDarkTheme";
import { setSessionStore } from "app/utils/sessionStore";
import { TRIGGER_SAVE_THEME_SETTINGS } from "app/redux/features/agent-branding";
import { useDispatch } from "react-redux";
import { ContactProfileDetailsContext } from "app/uicomponents/macrocomponents/ContactLayout";
import PrimeReact from "primereact/api";
import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import ThemeSelector from "app/pages/InteractiveProposal/menuPages/Header/ThemeSelector";
import { THEME } from "app/utils/types";

function DarkModeSelection() {
  const { isOpen } = useContext(ContactProfileDetailsContext);
  const { isDarkMode } = useContext(ThemeContext);
  const [, setTheme]: [string, Dispatch<SetStateAction<string>>] = useDarkTheme();
  const dispatch = useDispatch();
  useEffect(() => {
    setTheme(isDarkMode ? "dark" : "light");
    setSessionStore("globalTheme", isDarkMode ? "dark" : "light");
  }, [isDarkMode, setTheme]);
  const onThemeSelect = (value?: boolean) => {
    const newTheme = value ? "dark" : "light";
    const oldTheme = newTheme === "light" ? "dark" : "light";
    setSessionStore("globalTheme", value ? "dark" : "light");
    PrimeReact?.changeTheme?.(`lara-${oldTheme}-blue`, `lara-${newTheme}-blue`, "app-theme", () => {
      const allThemeLinks = document.querySelectorAll("link#app-theme");
      if (allThemeLinks.length > 1) {
        for (let i = 1; i < allThemeLinks.length; i++) {
          allThemeLinks[i].remove();
        }
      }
    });
    dispatch({
      type: TRIGGER_SAVE_THEME_SETTINGS,
      payload: {
        address: "saveThemeSettings",
        body: { theme: value ? "dark" : "light" },
      },
    });
  };

  // useEffect(() => {
  //   appTheme === "dark" && setIsDarkMode(true);
  // }, [appTheme]);

  return (
    <div className="full p-2 mt-2 relative group">
      <div className="flex justify-center">
        <ThemeSelector
          themeState={isDarkMode ? THEME.DARK : THEME.LIGHT}
          handleThemeClick={(selectedTheme: string) => onThemeSelect(selectedTheme === THEME.DARK)}
          isExpanded={isOpen}
          tooltipPosition="top"
          textClass="text-xs conthrax-font"
        />
      </div>
    </div>
  );
}

export default DarkModeSelection;
